<template>
    <div class="wrapper">
        <div style="min-height: 100vh">
            <HeaderPanel/>
            <div class="flex relative">
              <Sidebar/>
              <div class="main-wrapper">
                <router-view></router-view>
              </div>

              <FloatingWindowRoot name="floatingWindowRootBase" theme="light" position="fixed" />
            </div>
        </div>
        <GlobalLoaderIndicator/>
    </div>
</template>
<script>
    import Sidebar from '@/components/layout/Sidebar'
    import HeaderPanel from "@/components/layout/HeaderPanel";
    import GlobalLoaderIndicator from "@/components/ui/GlobalLoaderIndicator.vue"
    import FloatingWindowRoot from "@/components/floating/FloatingWindowRoot.vue";

    export default {
        components: {
            FloatingWindowRoot,
            HeaderPanel,
            Sidebar,
            GlobalLoaderIndicator
        }
    }
</script>
